import React, { useState, useCallback, useEffect, Fragment } from 'react'
import '../../styles/Accounts.css'
import AccountsService from '../../services/accounts.service'
import { useDispatch, useSelector } from 'react-redux'
import { setAccounts, setCurrentCarouselItem, setAccRefresh } from '../../actions'
import {
  carouselCurrentItemSelector,
  accountsSelector,
  isAccRefreshSelector,
  getMenuListSelector,
} from '../../selectors'
import NumberFormat from 'react-number-format'
import Loading from 'custom/assets/loaders/Loading'
import AccountCardLoader from '../../pages/new-design/contenet-loader/account-card-loader'
import AddIcon from 'custom/assets/common-icons/Add.svg' //! require new icon
import VisaLogo from 'custom/assets/common-icons/Visa.png' //! require new icon
import SelectedAccountSection from '../../components/SelectedAccountSection/SelectedAccountSection'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ACCOUNT_CARD_KEYS, CLIENT_NAME } from '../../utils/translation-constants'
export default function AccountsCard() {
  const [accountList, setAccountList] = useState([])
  const [selectedAccount, setSelectedAccount] = useState({})
  const dispatch = useDispatch()
  const accounts = useSelector(accountsSelector) || []
  const accountDetails = useSelector(carouselCurrentItemSelector) || {}
  const isAccRefresh = useSelector(isAccRefreshSelector) || {}
  const [showSelectedAccountInfo, setShowSelectedAccountInfo] = useState(false)
  const history = useHistory()
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector) || {}

  const accountTypes = {
    U: ACCOUNT_CARD_KEYS.CURRENT_ACC,
    S: ACCOUNT_CARD_KEYS.SAVING_ACC,
    C: ACCOUNT_CARD_KEYS.CURRENT_ACC,
    WA: ACCOUNT_CARD_KEYS.WALLET_ACC,
    SA: ACCOUNT_CARD_KEYS.SAVING_ACC,
  }

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = useCallback(async () => {
    try {
      if (accounts.length === 0 || isAccRefresh === true) {
        const response = await AccountsService.getAllAccounts()
        if (response.status === 200) {
          const casaAccountList = response.data['accountSummaryDetails']

          if (casaAccountList.length > 0) {
            setSelectedAccount(casaAccountList[0])
            dispatch(setAccRefresh(false))
            dispatch(setCurrentCarouselItem(casaAccountList[0]))

            const accountListCopy = [
              ...casaAccountList.filter((acc) => acc.accountNo !== casaAccountList[0].accountNo),
            ]
            setAccountList(accountListCopy)
            dispatch(setAccounts(casaAccountList))
          }
        }
      } else {
        if (accounts?.length > 0) {
          const accountListCopy = [
            ...accounts.filter((acc) => acc?.accountNo !== accountDetails?.accountNo),
          ]
          setAccountList(accounts?.length === 1 ? [] : accountListCopy)
          setSelectedAccount(accountDetails)
        }
      }
    } catch (err) {}
  }, [])

  const handleAccount = useCallback(
    (selected) => {
      const accountListCopy = [...accountList.filter((acc) => acc.accountNo !== selected.accountNo)]
      accountListCopy.push(selectedAccount)
      setAccountList(accountListCopy)
      setSelectedAccount(selected)
      dispatch(setCurrentCarouselItem(selected))
      // dispatch(setAccounts(accountListCopy))
    },
    [accountList, selectedAccount],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <div>
      {/* {accountList.length === 0 && (
        <div style={{ width: 300, height: '100vh' }}>{renderLoading()}</div>
      )} */}

      {Object.keys(selectedAccount).length === 0 && <AccountCardLoader />}

      {Object.keys(selectedAccount).length > 0 && (
        <>
          <div
            className='account-selected-card d-flex flex-column justify-content-around cursor-pointer'
            onClick={() => setShowSelectedAccountInfo(!showSelectedAccountInfo)}>
            <div className='d-flex justify-content-between'>
              {/* <div>
                <h6>{t(CLIENT_NAME.CLIENT_CARD_LABEL)}</h6> */}
              {/* <img src={VisaLogo} alt='visa' className='' height={11} /> */}
              {/* VISA */}
              {/* </div> */}
            </div>
            <div className=''>
              <span className='mr-2 account-number'>{t(ACCOUNT_CARD_KEYS.ACC_NO)}</span>
              <NumberFormat
                className='account-number'
                value={selectedAccount?.accountNo}
                displayType={'text'}
                format='#### #### #### #####'
              />
            </div>

            <div className='position-relative mt-2'>
              <div className='balance-label'>{t(ACCOUNT_CARD_KEYS.CURRENT_BALANCE)}</div>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <span className='font-weight-500 pr-1' style={{ fontSize: 9 }}>
                    {selectedAccount.currency}
                  </span>
                  <NumberFormat
                    className='balance'
                    value={selectedAccount?.currBal}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
              </div>
            </div>

            <div className='position-relative'>
              <div className='balance-label'>{t(ACCOUNT_CARD_KEYS.AVAILABLE_BALANCE)}</div>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <span className='font-weight-500 pr-1' style={{ fontSize: 9 }}>
                    {selectedAccount.currency}
                  </span>
                  <NumberFormat
                    className='balance'
                    value={selectedAccount?.avlBal}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='account-card-desc'>{t(ACCOUNT_CARD_KEYS.SELECT_OPERATION)}</div>

          {showSelectedAccountInfo && (
            <div
              className='mx-auto'
              style={{
                width: 300,
                borderRadius: 10,
              }}>
              <SelectedAccountSection
                selectedAccount={selectedAccount}
                close={() => setShowSelectedAccountInfo(false)}
              />
            </div>
          )}

          {menuConfig['ADD_ACCOUNT'] && (
            <div className='open-account-card d-flex flex-column justify-content-center'>
              <div
                className='d-flex justify-content-center cursor-pointer'
                onClick={() => history.push('/add-account')}>
                <div className='mr-3'>
                  <img src={AddIcon} alt={'add icon'} className='' />
                </div>
                <div className='my-auto'>
                  <div className='title font-weight-bold'>{t(ACCOUNT_CARD_KEYS.OPEN_ACCOUNT)}</div>
                  <div className='content font-weight-500'>
                    {t(ACCOUNT_CARD_KEYS.OPEN_ACCOUNT_DESC)}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div>
            {accountList.map((account, index) => (
              <div key={index} className='account-card'>
                <div className='accounts-detail' onClick={() => handleAccount(account)}>
                  <span className='label'>
                    {t(accountTypes[account.accountType])}
                    {/* {account.accountType === 'U' && t(ACCOUNT_CARD_KEYS.CURRENT_ACC)}
                    {account.accountType === 'S' && t(ACCOUNT_CARD_KEYS.SAVING_ACC)}
                    {account.accountType === 'WA' && t(ACCOUNT_CARD_KEYS.WALLET_ACC)} */}
                  </span>
                  <div className='d-flex justify-content-between mt-2'>
                    <div className='balance'>
                      <label>{t(ACCOUNT_CARD_KEYS.CURRENT_ACCOUNT)}</label>

                      <div>
                        <NumberFormat
                          value={account?.currBal}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                    </div>
                    <div className='balance'>
                      <label>{t(ACCOUNT_CARD_KEYS.AVAILABLE_ACCOUNT)}</label>

                      <div>
                        <NumberFormat
                          value={account?.avlBal}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
